import React, {FC} from 'react';
import styled from 'styled-components';

import {globalNamespace} from '../../../../../../../../../src/helpers/models/namespaceHelpers';
import {ContactsTableMergeActionContainer} from './mulitSelectActions/contactsTableMergeActionContainer';
import {ContactsTableMessageActionContainer} from './mulitSelectActions/contactsTableMessageActionContainer';
import {ContactsTableMultiDeleteActionContainer} from './mulitSelectActions/contactsTableMultiDeleteActionContainer';
import {ContactsTableMultiListsActionContainer} from './mulitSelectActions/contactsTableMultiListsActionContainer';
import {ContactsTableMultiRemoveFromListActionContainer} from './mulitSelectActions/contactsTableMultiRemoveFromListActionContainer';

/*
 * Props.
 */

interface ContactsTableMultiSelectActionsProps {
  isAddToListsButtonVisible?: boolean;
  namespace?: string;
  cardIds: ReadonlyArray<number>;
  cardGroupId?: number;
  shouldHideRemoveFromListsAction?: boolean;
  shouldHideMergeAction?: boolean;
  shouldHideDeleteAction?: boolean;
}

/*
 * Style.
 */

const StyledContactsTableMultiSelectActionsContainerDiv = styled.div`
  display: flex;
  flex-flow: row;
  gap: 8px;
`;

/*
 * Component.
 */

export const ContactsTableMultiSelectActions: FC<ContactsTableMultiSelectActionsProps> = (props) => {
  const {
    isAddToListsButtonVisible,
    shouldHideRemoveFromListsAction = false,
    namespace,
    cardIds,
    cardGroupId,
    shouldHideMergeAction,
    shouldHideDeleteAction,
  } = props;

  return (
    <StyledContactsTableMultiSelectActionsContainerDiv>
      <ContactsTableMessageActionContainer cardIds={cardIds} />
      {isAddToListsButtonVisible && (
        <ContactsTableMultiListsActionContainer
          shouldHideRemoveFromListsAction={shouldHideRemoveFromListsAction}
          cardIds={cardIds}
          namespace={namespace ?? globalNamespace}
        />
      )}
      {!shouldHideMergeAction && <ContactsTableMergeActionContainer cardIds={cardIds} />}
      {cardGroupId && (
        <ContactsTableMultiRemoveFromListActionContainer cardGroupId={cardGroupId} cardIds={cardIds} />
      )}
      {!shouldHideDeleteAction && <ContactsTableMultiDeleteActionContainer cardIds={cardIds} />}
    </StyledContactsTableMultiSelectActionsContainerDiv>
  );
};
